import railyApiService from "../raily-api.service";
import orderForwardEditRequestFactory from "./edit/order-forward-edit-request.factory";
import OrderForwardEditRequest from "./edit/order-forward-edit.request";
import OrderForwardEditResponse from "./edit/order-forward-edit.response";
import orderForwardListRequestFactory from "./list/order-forward-list-request.factory";
import OrderForwardListRequest, {
  OrderForwardListQueryParams,
} from "./list/order-forward-list.request";
import OrderForwardListResponse from "./list/order-forward-list.response";

const orderForwardApiService = () => {
  const getList = (
    request: OrderForwardListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderForwardListResponse> => {
    const url = `/order-forwardings/not-yet-billed`;

    const queryParams: OrderForwardListQueryParams =
      orderForwardListRequestFactory.createQueryParams(request);

    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const editForwarding = (
    request: OrderForwardEditRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderForwardEditResponse> => {
    const url = `/order-forwardings/${request.forwardingId}`;

    const body = orderForwardEditRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  return { getList, editForwarding };
};

export default orderForwardApiService;
